import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Inject,
    OnDestroy,
    OnInit,
    Optional,
    ViewEncapsulation,
    signal,
} from '@angular/core';
import {
    MAT_SNACK_BAR_DATA,
    MatSnackBarRef,
} from '@angular/material/snack-bar';
import {
    MessageAction,
    MessageObserverService,
} from '../../../services/message-observer.service';
import { MatButton, MatIconButton } from '@angular/material/button';
import { TranslatePipe } from '@ngx-translate/core';
import { environment } from '../../../../../../../environments/environment';
import { NgClass } from '@angular/common';

@Component({
    selector: 'tw-snack-bar',
    templateUrl: './snack-bar.component.html',
    styleUrls: ['./snack-bar.component.css'],
    encapsulation: ViewEncapsulation.None,
    imports: [MatButton, TranslatePipe, NgClass,MatIconButton],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SnackBarComponent implements OnInit, OnDestroy {
    error = signal<any[]>([]);
    sub = [];
    snackBarClass = signal('');
    dataSignal = signal<MessageAction | null>(null);

    constructor(
        @Optional() @Inject(MAT_SNACK_BAR_DATA) public data: MessageAction,
        public snackBarRef: MatSnackBarRef<SnackBarComponent>,
        public messageObserverService: MessageObserverService,
        private cdr: ChangeDetectorRef,
    ) {}

    ngOnInit() {
        this.dataSignal.set(this.data);
        this.error.set([]);
        const a = this.messageObserverService
            .watchMessage()
            .subscribe((value) => {
                if (
                    !value ||
                    !value.snackBar ||
                    this.error().find(
                        (e) => JSON.stringify(e) === JSON.stringify(value),
                    )
                ) {
                    return;
                }
                this.dataSignal.set(null);
                this.error.update(errors => [...errors, value]);
                this.dataSignal.set(value);
                this.cdr.markForCheck();
                if (!value.snackBar.panelClass) {
                    if (environment.systemValues === 'tkp') {
                        this.snackBarClass.set('border-left border-left-color-500');
                    }
                }
                this.cdr.markForCheck();
            });
        this.sub.push(a);
    }

    closeSnack() {
        this.snackBarRef.dismiss();
    }

    ngOnDestroy(): void {
        this.sub.forEach((s) => s.unsubscribe());
    }
}
